"use client";
import { useContext, useEffect } from "react";

import { ZendeskContext, zendeskHideCounter } from "@stadium/services/zendesk/provider";

import { SERVER_PHASE } from "@stadium/constants";

const ZendeskIconHideWrapper = ({ children, hideIcon = true }) => {
  const { zendeskLoaded } = useContext(ZendeskContext);
  const isZeLoaded = !SERVER_PHASE && typeof window.zE !== "undefined" && zendeskLoaded;

  const getzEMessenger = (action) => {
    isZeLoaded && window.zE("messenger", action);
  };

  useEffect(() => {
    if (hideIcon) {
      zendeskHideCounter.increase();
      //added setTimeout to avoid race condition with callback called when prev screen is unmounted.
      setTimeout(() => {
        getzEMessenger("hide");
      }, 500);

      return () => {
        zendeskHideCounter.decrease();
        if (zendeskHideCounter.val === 0) getzEMessenger("show");
      };
    }
  }, [isZeLoaded, hideIcon]);

  return children;
};
export default ZendeskIconHideWrapper;
